document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.sfera-header');
  const hamburger = document.querySelector('.sfera-header__hamburger');
  const drawer = document.querySelector('.sfera-header__drawer');
  const closeButton = document.querySelector('.sfera-header__drawer-close');

  const setHeaderHeight = () => {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  };

  setHeaderHeight();


  // While a popup or drawer locks the page (on iPhone the lock pins <body> or <html> with
  // position: fixed), window.scrollY reads 0. Keep the header as it was; otherwise it turns
  // transparent over the page behind the popup (seen on the live store, 20-oct-2026).
  const pageLocked = () =>
    document.body.style.position === 'fixed' || document.documentElement.style.position === 'fixed';

  // Sticky header
  window.addEventListener('scroll', () => {
    if (pageLocked()) return;
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });

  // Set support block height CSS variable
  const supportWrapper = document.querySelector('.sfera-header__drawer-support-wrapper');
  if (supportWrapper) {
    const updateSupportHeight = () => {
      drawer.style.setProperty('--drawer-support-height', supportWrapper.offsetHeight + 'px');
    };
    updateSupportHeight();
    window.addEventListener('resize', updateSupportHeight);
  }

  // Hamburger menu
  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('active');
    drawer.classList.toggle('active');
    document.body.classList.toggle('drawer-open');
  });

  // Close / Back button
  const resetPanels = () => {
    document.querySelectorAll('.sfera-header__drawer-panel').forEach((p) => {
      p.classList.remove('is-active', 'is-prev');
    });
    const rootPanel = document.querySelector('.sfera-header__drawer-panel[data-depth="0"]');
    if (rootPanel) rootPanel.classList.add('is-active');
  };

  const findParentPanel = (currentPanel) => {
    let parent = null;
    document.querySelectorAll('.sfera-header__drawer-panel.is-prev').forEach((p) => {
      p.querySelectorAll('[data-submenu-trigger]').forEach((t) => {
        const wrapper = document.querySelector(`[data-submenu-panel="${t.dataset.submenuTrigger}"]`);
        if (wrapper && wrapper.contains(currentPanel)) {
          parent = p;
        }
      });
    });
    return parent;
  };

  closeButton.addEventListener('click', () => {
    const activePanel = document.querySelector('.sfera-header__drawer-panel.is-active');
    const isRoot = !activePanel || activePanel.dataset.depth === '0';

    if (isRoot) {
      // Close the drawer
      hamburger.classList.remove('active');
      drawer.classList.remove('active');
      document.body.classList.remove('drawer-open');
      setTimeout(() => {
        resetPanels();
        if (supportWrapper) supportWrapper.classList.remove('is-hidden');
      }, 300);
    } else {
      // Go back to parent panel
      const parentPanel = findParentPanel(activePanel);
      if (parentPanel) {
        activePanel.classList.remove('is-active');
        parentPanel.classList.remove('is-prev');
        parentPanel.classList.add('is-active');
        // Show support wrapper only when returning to root
        if (parentPanel.dataset.depth === '0' && supportWrapper) {
          supportWrapper.classList.remove('is-hidden');
        }
      }
    }
  });

  // Localization form submission
  const localizationForms = document.querySelectorAll('.sfera-header__localization-form');

  localizationForms.forEach(form => {
    const select = form.querySelector('select');
    const label = form.querySelector('.custom-select-label');

    if (select && label) {

      // Update label on change and submit form
      select.addEventListener('change', function() {
        label.textContent = this.options[this.selectedIndex].textContent;
        form.submit();
      });
    }
  });

  // Sliding pill effect
  const menu = document.querySelector('.sfera-header__menu');
  const pill = document.querySelector('.sfera-header__pill');
  const menuItems = menu?.querySelectorAll('li:not(.sfera-header__pill)');

  let activeDropdownTrigger = null;

  if (menu && pill && menuItems.length) {
    const updatePill = (item) => {
      const menuRect = menu.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();

      pill.style.width = `${itemRect.width}px`;
      pill.style.height = `${itemRect.height}px`;
      pill.style.transform = `translateX(${itemRect.left - menuRect.left - 6}px)`;
    };

    menuItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        pill.style.opacity = '1';
        updatePill(item);
      });
    });

    menu.addEventListener('mouseleave', () => {
      // Delay pill hide to allow entering the dropdown gap
      setTimeout(() => {
        if (!activeDropdownTrigger) {
          pill.style.opacity = '0';
        }
      }, 100);
    });
  }

  // Menu dropdown hover
  const dropdownTriggers = document.querySelectorAll('[data-dropdown-trigger]');
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  const resetDropdownPanels = (dropdown) => {
    dropdown.querySelectorAll('.sfera-header__dropdown-panel').forEach((p) => {
      p.classList.remove('is-active', 'is-prev');
    });
    const rootPanel = dropdown.querySelector('.sfera-header__dropdown-panel[data-dropdown-depth="0"]');
    if (rootPanel) rootPanel.classList.add('is-active');
    dropdown.style.height = '';
  };

  const updateDropdownHeight = (dropdown, panel) => {
    dropdown.style.height = panel.scrollHeight + 'px';
  };

  dropdownTriggers.forEach(trigger => {
    const dropdownId = trigger.dataset.dropdownTrigger;
    const dropdown = document.querySelector(`[data-dropdown="${dropdownId}"]`);

    if (!dropdown) return;

    let hideTimeout;
    let resetTimeout;

    const showDropdown = () => {
      clearTimeout(hideTimeout);
      clearTimeout(resetTimeout);
      dropdowns.forEach(d => {
        if (d !== dropdown) {
          d.classList.remove('is-active');
          d.style.pointerEvents = '';
          resetDropdownPanels(d);
        }
      });
      activeDropdownTrigger = trigger;
      if (pill) {
        pill.style.opacity = '1';
        const menuRect = menu.getBoundingClientRect();
        const triggerRect = trigger.getBoundingClientRect();
        pill.style.width = `${triggerRect.width}px`;
        pill.style.height = `${triggerRect.height}px`;
        pill.style.transform = `translateX(${triggerRect.left - menuRect.left - 6}px)`;
      }
      dropdown.style.pointerEvents = '';
      // Align dropdown cards with the active pill/trigger
      const nav = dropdown.closest('.sfera-header__navigation');
      if (nav) {
        const navRect = nav.getBoundingClientRect();
        const triggerRect2 = trigger.getBoundingClientRect();
        const dropdownPadding = parseFloat(getComputedStyle(dropdown).paddingLeft) || 16;
        dropdown.style.left = `${triggerRect2.left - navRect.left - dropdownPadding}px`;
      }
      dropdown.classList.add('is-active');
      const activePanel = dropdown.querySelector('.sfera-header__dropdown-panel.is-active');
      if (activePanel) updateDropdownHeight(dropdown, activePanel);
    };

    const hideDropdown = () => {
      hideTimeout = setTimeout(() => {
        if (activeDropdownTrigger === trigger) {
          activeDropdownTrigger = null;
          if (pill) pill.style.opacity = '0';
        }
        dropdown.style.pointerEvents = 'none';
        dropdown.classList.remove('is-active');
        resetTimeout = setTimeout(() => {
          resetDropdownPanels(dropdown);
          dropdown.style.pointerEvents = '';
        }, 300);
      }, 200);
    };

    trigger.addEventListener('mouseenter', showDropdown);
    trigger.addEventListener('mouseleave', hideDropdown);

    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(hideTimeout);
      clearTimeout(resetTimeout);
      activeDropdownTrigger = trigger;
      if (pill) {
        pill.style.opacity = '1';
        const menuRect = menu.getBoundingClientRect();
        const triggerRect = trigger.getBoundingClientRect();
        pill.style.width = `${triggerRect.width}px`;
        pill.style.height = `${triggerRect.height}px`;
        pill.style.transform = `translateX(${triggerRect.left - menuRect.left - 6}px)`;
      }
    });

    dropdown.addEventListener('mouseleave', hideDropdown);
  });

  // CTA dropdown (desktop hover) + modal (mobile tap)
  const ctaWrapper = document.querySelector('[data-cta-dropdown]');
  const ctaDropdown = document.querySelector('[data-cta-dropdown-menu]');
  const ctaModal = document.querySelector('[data-cta-modal]');
  const ctaModalTrigger = document.querySelector('[data-cta-modal-trigger]');

  if (ctaWrapper && ctaDropdown && window.matchMedia('(min-width: 750px)').matches) {
    let ctaHideTimeout;

    const showCta = () => {
      clearTimeout(ctaHideTimeout);
      ctaDropdown.classList.add('is-active');
    };

    const hideCta = () => {
      ctaHideTimeout = setTimeout(() => {
        ctaDropdown.style.pointerEvents = 'none';
        ctaDropdown.classList.remove('is-active');
        setTimeout(() => { ctaDropdown.style.pointerEvents = ''; }, 300);
      }, 200);
    };

    ctaWrapper.addEventListener('mouseenter', showCta);
    ctaWrapper.addEventListener('mouseleave', hideCta);
  }

  if (ctaModal && ctaModalTrigger) {
    ctaModalTrigger.addEventListener('click', (e) => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        e.preventDefault();
        ctaModal.showModal();
      }
    });

    // Close when clicking the backdrop (outside dialog bounds)
    ctaModal.addEventListener('click', (e) => {
      if (e.target === ctaModal) ctaModal.close();
    });
  }

  // Desktop dropdown sub-menu sliding
  document.querySelectorAll('[data-dropdown-submenu-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = trigger.dataset.dropdownSubmenuTrigger;
      const dropdown = trigger.closest('.sfera-header__dropdown');
      const currentPanel = trigger.closest('.sfera-header__dropdown-panel');
      const targetWrapper = dropdown.querySelector(`[data-dropdown-submenu-panel="${targetId}"]`);
      const targetPanel = targetWrapper?.querySelector('.sfera-header__dropdown-panel');

      if (currentPanel && targetPanel) {
        // Lock current height so transition has a start value
        dropdown.style.height = dropdown.offsetHeight + 'px';

        currentPanel.classList.remove('is-active');
        currentPanel.classList.add('is-prev');
        targetPanel.classList.add('is-active');

        // Set target height on next frame to trigger animation
        requestAnimationFrame(() => {
          updateDropdownHeight(dropdown, targetPanel);
        });
      }
    });
  });

  // Mobile drawer sliding sub-menus
  document.querySelectorAll('[data-submenu-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = trigger.dataset.submenuTrigger;
      const currentPanel = trigger.closest('.sfera-header__drawer-panel');
      const targetWrapper = document.querySelector(`[data-submenu-panel="${targetId}"]`);
      const targetPanel = targetWrapper?.querySelector('.sfera-header__drawer-panel');

      if (currentPanel && targetPanel) {
        currentPanel.classList.remove('is-active');
        currentPanel.classList.add('is-prev');
        targetPanel.classList.add('is-active');
        if (supportWrapper) supportWrapper.classList.add('is-hidden');
      }
    });
  });

});
